import {
	IDisablePullToRefreshAction,
	IGetBounceAction,
	ISetActiveBreakpoint,
	IToggleSideDrawerAction,
	IToggleSoundAction,
	IVideoIsLoadedAction
} from "src/store//StoreInterface";
import * as actionTypes from "src/store/actions//actionTypes";

export const disablePullToRefresh = (
	pullToRefreshDisabled: boolean
): IDisablePullToRefreshAction => {
	return {
		payload: pullToRefreshDisabled,
		type: actionTypes.DISABLE_PULL_TO_REFRESH
	};
};

export const getBounce = (bounce: boolean): IGetBounceAction => {
	return {
		payload: bounce,
		type: actionTypes.GET_BOUNCE
	};
};

export const setActiveBreakpoint = (
	breakpointName: string
): ISetActiveBreakpoint => {
	return {
		payload: {
			breakpointName
		},
		type: actionTypes.SET_ACTIVE_BREAKPOINT
	};
};

export const toggleSideDrawer = (
	showSideDrawer: boolean
): IToggleSideDrawerAction => {
	return {
		payload: showSideDrawer,
		type: actionTypes.TOGGLE_SIDEDRAWER
	};
};

export const toggleSound = (muted: boolean): IToggleSoundAction => {
	return {
		payload: muted,
		type: actionTypes.TOGGLE_SOUND
	};
};

export const videoIsLoaded = (videoLoaded: boolean): IVideoIsLoadedAction => {
	return {
		payload: videoLoaded,
		type: actionTypes.VIDEO_IS_LOADED
	};
};



// WEBPACK FOOTER //
// ./src/store/actions/ui.tsx